<template>
  <div class="card mb-3">
    <div class="card-header bg-light">
      <h5 class="mb-0">Campos de relación y configuración</h5>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-lg-4">
          <div class="form-group">
            <label for="subsidizable_actuation_id">Actuaciones subvencionables</label>
            <select
              :value="localResume.subsidizable_actuation_id"
              @change="updateField('subsidizable_actuation_id', parseSelectValue($event.target.value))"
              class="form-control"
              id="subsidizable_actuation_id"
            >
              <option :value="null">Seleccione una opción</option>
              <option
                v-for="option in selectOptionsSubsidizableActuations"
                :key="option.value"
                :value="option.value"
              >
                {{ option.text }}
              </option>
            </select>
            <small v-if="selectOptionsSubsidizableActuations.length === 0" class="text-muted">
              No hay actuaciones subvencionables disponibles para este proyecto
            </small>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="subsidizable_action_id">Acciones subvencionables</label>
            <select
              :value="localResume.subsidizable_action_id"
              @change="updateField('subsidizable_action_id', parseSelectValue($event.target.value))"
              class="form-control"
              id="subsidizable_action_id"
            >
              <option :value="null">Seleccione una opción</option>
              <option
                v-for="option in selectOptionsSubsidizableActions"
                :key="option.value"
                :value="option.value"
              >
                {{ option.text }}
              </option>
            </select>
            <small v-if="selectOptionsSubsidizableActions.length === 0" class="text-muted">
              No hay acciones subvencionables disponibles para este proyecto
            </small>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="coding_id">Codificación</label>
            <select
              :value="localResume.coding_id"
              @change="updateField('coding_id', parseSelectValue($event.target.value))"
              class="form-control"
              id="coding_id"
            >
              <option :value="null">Seleccione una opción</option>
              <option
                v-for="option in selectOptionsCodings"
                :key="option.value"
                :value="option.value"
              >
                {{ option.text }}
              </option>
            </select>
            <small v-if="selectOptionsCodings.length === 0" class="text-muted">
              No hay codificaciones disponibles para este proyecto
            </small>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4">
          <div class="form-group">
            <label for="phase_id">Fase</label>
            <select
              :value="localResume.phase_id"
              @change="updateField('phase_id', parseSelectValue($event.target.value))"
              class="form-control"
              id="phase_id"
            >
              <option :value="null">Seleccione una opción</option>
              <option
                v-for="option in selectOptionsPhases"
                :key="option.value"
                :value="option.value"
              >
                {{ option.text }}
              </option>
            </select>
            <small v-if="selectOptionsPhases.length === 0" class="text-muted">
              No hay fases disponibles para este proyecto
            </small>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="primary_project_id">Proyecto Primario</label>
            <select
              :value="localResume.primary_project_id"
              @change="updateField('primary_project_id', parseSelectValue($event.target.value))"
              class="form-control"
              id="primary_project_id"
            >
              <option :value="null">Seleccione una opción</option>
              <option
                v-for="option in selectOptionsPrimaryProjects"
                :key="option.value"
                :value="option.value"
              >
                {{ option.text }}
              </option>
            </select>
            <small v-if="selectOptionsPrimaryProjects.length === 0" class="text-muted">
              No hay proyectos primarios disponibles para este proyecto
            </small>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="expense_typology_id">Tipología de gasto</label>
            <select
              :value="localResume.expense_typology_id"
              @change="updateField('expense_typology_id', parseSelectValue($event.target.value))"
              class="form-control"
              id="expense_typology_id"
            >
              <option :value="null">Seleccione una opción</option>
              <option
                v-for="option in selectOptionsExpenseTypologies"
                :key="option.value"
                :value="option.value"
              >
                {{ option.text }}
              </option>
            </select>
            <small v-if="selectOptionsExpenseTypologies.length === 0" class="text-muted">
              No hay tipologías de gasto disponibles para este proyecto
            </small>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4">
          <div class="form-group">
            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                id="expense_outside_spain_in_eu"
                :checked="localResume.expense_outside_spain_in_eu"
                @change="updateField('expense_outside_spain_in_eu', $event.target.checked)"
              />
              <label class="custom-control-label" for="expense_outside_spain_in_eu">
                ¿Gasto fuera de España dentro de UE?
              </label>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                id="expense_outside_eu"
                :checked="localResume.expense_outside_eu"
                @change="updateField('expense_outside_eu', $event.target.checked)"
              />
              <label class="custom-control-label" for="expense_outside_eu">
                ¿Gasto fuera de UE?
              </label>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="justification_type">
              Tipo de Justificación <span class="text-danger">*</span>
            </label>
            <select
              :value="localResume.justification_type"
              @change="updateField('justification_type', $event.target.value)"
              @blur="v.justification_type && v.justification_type.$touch()"
              class="form-control"
              :class="{ 'is-invalid': v.justification_type && v.justification_type.$error }"
              id="justification_type"
              required
            >
              <option
                v-for="option in justificationTypeOptions"
                :key="option.value"
                :value="option.value"
              >
                {{ option.text }}
              </option>
            </select>
            <div v-if="v.justification_type && v.justification_type.$error" class="invalid-feedback">
              <div v-if="!v.justification_type.required">{{ errorMessages.required }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { errorMessages } from "@/helpers/validations/errorMessages";
import { autoSelectMixin } from "@/helpers/mixins/autoSelectMixin";

export default {
  name: "RelationsConfigSection",
  mixins: [autoSelectMixin],
  props: {
    localResume: {
      type: Object,
      required: true,
    },
    v: {
      type: Object,
      required: true,
    },
    selectOptionsSubsidizableActuations: {
      type: Array,
      default: () => [],
    },
    selectOptionsSubsidizableActions: {
      type: Array,
      default: () => [],
    },
    selectOptionsCodings: {
      type: Array,
      default: () => [],
    },
    selectOptionsPhases: {
      type: Array,
      default: () => [],
    },
    selectOptionsPrimaryProjects: {
      type: Array,
      default: () => [],
    },
    selectOptionsExpenseTypologies: {
      type: Array,
      default: () => [],
    },
    justificationTypeOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      errorMessages,
      // Auto-select configuration
      // Set enabled: false to disable auto-select for a specific field
      autoSelectConfig: {
        subsidizable_actuation_id: {
          options: () => this.selectOptionsSubsidizableActuations,
          enabled: true,
          skipIfValueExists: true,
        },
        subsidizable_action_id: {
          options: () => this.selectOptionsSubsidizableActions,
          enabled: true,
          skipIfValueExists: true,
        },
        coding_id: {
          options: () => this.selectOptionsCodings,
          enabled: true,
          skipIfValueExists: true,
        },
        phase_id: {
          options: () => this.selectOptionsPhases,
          enabled: true,
          skipIfValueExists: true,
        },
        primary_project_id: {
          options: () => this.selectOptionsPrimaryProjects,
          enabled: true,
          skipIfValueExists: true,
        },
        expense_typology_id: {
          options: () => this.selectOptionsExpenseTypologies,
          enabled: true,
          skipIfValueExists: true,
        },
        // justification_type is excluded from auto-select as it has a default value
      },
    };
  },
  mounted() {
    this.setupAutoSelect();
  },
  methods: {
    parseSelectValue(value) {
      if (!value || value === "" || value === "null" || value === "undefined") {
        return null;
      }
      const parsed = Number.parseInt(value, 10);
      return Number.isNaN(parsed) ? null : parsed;
    },
    updateField(field, value) {
      // Reset auto-select tracking when user manually changes value
      this.resetAutoSelect(field);
      this.$emit("update:field", field, value);
    },
  },
};
</script>
